import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Console } from 'console';
import { Observable } from 'rxjs/Observable';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AmdReportService {

  constructor(public http: HttpClient) { }

  serviceApiUrl: string = environment.serviceApiUrl;

  fetchAllAsset() {
    //
    // console.log("service get;;;;;")
    return this.http.get<Observable<any>>(this.serviceApiUrl + 'm_asset/all');

  }

  fetchBeNumber(beNumber) {
    return this.http.post<Array<any>>(this.serviceApiUrl + 'm_asset/fetchBENumber', beNumber);

  }
  fetchModifyBeNumber(beNumber) {
    return this.http.post<Array<any>>(this.serviceApiUrl + 'mAsset/fetchByBenumber', beNumber);

  }
  fetchBENumberServiceHistoryCurrent(beNumber) {
    console.log('benumber', beNumber)
    return this.http.get<Array<any>>(this.serviceApiUrl + 'm_asset_mapping/fetchServiceByBeNumberRecent?beNumber=' + beNumber);
  }
  fetchBENumberServiceHistoryOld(beNumber) {
    console.log('benumber', beNumber)
    return this.http.get<Array<any>>(this.serviceApiUrl + 'm_asset_mapping/fetchServiceByBeNumber?beNumber=' + beNumber);
  }
  fetchBENumberHistory(id) {
    
    return this.http.get<Array<any>>(this.serviceApiUrl + 'mAsset/beNumberHistory?id=' + id);
  }
  fetchOldBeNumberHistory(id) {
    
    return this.http.get<Array<any>>(this.serviceApiUrl + 'mAsset/oldBeNumberHistory?id=' + id);
  }
  spareHistoryExcel(beNumber) {
    console.log('benumber', beNumber)
    return this.http.get<Array<any>>(this.serviceApiUrl + 'sparesHistory/spareHistoryDetailsForExcel?beNumber=' + beNumber);
  }
  fetchBENumberSparesHistoryCurrent(beNumber) {
    return this.http.get<Array<any>>(this.serviceApiUrl + 'sparesHistory/currentSparesByBeNumber?beNumber=' + beNumber);
  }
  fetchBENumberSparesHistoryPrevious(beNumber) {
    return this.http.get<Array<any>>(this.serviceApiUrl + 'sparesHistory/spareHistoryByBeNumber?beNumber=' + beNumber);
  }
  fetchBENumberMaterialHistory(beNumber, mrNumber) {
    return this.http.get<Array<any>>(this.serviceApiUrl + 'sparesHistory/sparesMrData?beNumber=' + beNumber + '&mrNumber=' + mrNumber);
  }
  fetchAllConditionalStatus() {
    return this.http.get<Array<any>>(this.serviceApiUrl + 'conditionalStatus/all')
  }

  filterConditionalStatus(stateName, districtName, clinicCode, beCategory, beOldStatus, beNewStatus) {

    return this.http.get<Array<any>>(this.serviceApiUrl + 'conditionalStatus/filter?stateName=' + stateName + "&districtName=" + districtName + "&clinicCode=" + clinicCode + "&beCategory=" + beCategory + "&beOldStatus=" + beOldStatus + "&beNewStatus=" + beNewStatus)
  }

  filterLocationChange(stateIdFilter, beCategoryFilter, beStatusFilter, districtIdFilterOld, clinicCodeFilterOld, circleCodeFilterOld, districtIdFilterNew, clinicCodeFilterNew, circleCodeFilterNew) {

    return this.http.get<Array<any>>(this.serviceApiUrl + 'locationChange/filter?stateId=' + stateIdFilter + "&becategory=" + beCategoryFilter + "&assetConditionalStatusCode=" + beStatusFilter + "&districtOldId=" + districtIdFilterOld + "&clinicCodeOld=" + clinicCodeFilterOld + "&circleCodeOld=" + circleCodeFilterOld
      + "&districtNewId=" + districtIdFilterNew + "&clinicCodeNew=" + clinicCodeFilterNew + "&circleCodeNew=" + circleCodeFilterNew)
  }

  // saveConditionalStatus(beNumberData){
  //   return this.http.post<Array<any>>(this.serviceApiUrl + 'conditionalStatus/add',beNumberData)
  // }

  saveConditionalStatus(beNumberData, file: File) {

    const formData: FormData = new FormData();
    formData.append("conditionalStatus", JSON.stringify(beNumberData));
    formData.append("File", file);

    const req = new HttpRequest('POST', `${this.serviceApiUrl}/conditionalStatus/add`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);

    // return this.http.post(this.serviceApiUrl + 'locationChange/add',beNumberData)
  }

  updateConditionalStatus(beNumberData) {
    return this.http.put<Array<any>>(this.serviceApiUrl + 'conditionalStatus/update', beNumberData)
  }

  fetchConditionalStatusById(cndStatusId) {
    return this.http.post<Array<any>>(this.serviceApiUrl + 'conditionalStatus/fetchById', cndStatusId)
  }

  fetchConditionalBeNumber(beNumber) {
    return this.http.post<Array<any>>(this.serviceApiUrl + 'conditionalStatus/fetchConditionalBeNumber', beNumber);

  }

  fetchAllLocationChange() {
    return this.http.get<Array<any>>(this.serviceApiUrl + 'locationChange/all')
  }

  fetchBeNumberLocationChange(benumber) {
    return this.http.post<Array<any>>(this.serviceApiUrl + 'locationChange/fetchLocationBeNumber', benumber)
  }

  saveLocationChange(beNumberData, file: File) {

    const formData: FormData = new FormData();
    formData.append("locationChange", JSON.stringify(beNumberData));
    formData.append("File", file);

    const req = new HttpRequest('POST', `${this.serviceApiUrl}/locationChange/add`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);

    // return this.http.post(this.serviceApiUrl + 'locationChange/add',beNumberData)
  }


  fetchLocationChangeById(locChngId) {
    return this.http.post<Array<any>>(this.serviceApiUrl + 'locationChange/fetchById', locChngId)
  }

  updateLocationChange(data) {
    return this.http.put<Array<any>>(this.serviceApiUrl + "locationChange/update", data)
  }

  // fetchloBeNumber(beNumber){
  //   return this.http.post<Array<any>>(this.serviceApiUrl + 'conditionalStatus/fetchConditionalBeNumber',beNumber);
  // }
  public fetchClinicsDetails(stateId, districtId, circleId) {
    return this.http.get<Array<any>>(this.serviceApiUrl + '/clinic/stateid-districtid-circleId?stateId=' + stateId + '&districtId=' + districtId + '&circleId=' + circleId)
  }

  public sendExcelFile(file: File) {
    console.log("Service File : ", file)

    const formData: FormData = new FormData();

    formData.append("excelFile", file);

    const req = new HttpRequest('POST', `${this.serviceApiUrl}/m_asset/beRegistraion`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  // reLocation Change..
  public uploadFile(file: File) {

    const formData: FormData = new FormData();

    formData.append("excelFile", file);

    const req = new HttpRequest('POST', `${this.serviceApiUrl}/m_asset/beRegistraion`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);

  }

  public fetchAssetSecondary() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + 'assetSecondary/all');
  }

  public saveAssetSecondary(tassetObj,file1:File,fileNamePlate:File,file3:File,file4:File,file5:File,file6:File,file7:File,file8:File,file9:File,file10:File,file11:File,file12:File
    ,file13:File,file14:File,file15:File,file16:File,file17:File,file18:File,file19:File,file20:File,file21:File,file22:File,file23:File){

    const formData: FormData = new FormData();
    formData.append("assetSecondary",JSON.stringify(tassetObj));
    // file2
    formData.append("FormA04",file23);
    formData.append("EquipmentPicture",file1);
    formData.append("NumberPlatePicture",fileNamePlate);
    formData.append("DeliveryOrder",file3);
    formData.append("BETCChecklist",file4);
    formData.append("TCCertificate",file5);
    formData.append("VarDocuments",file6);
    formData.append("SuratTawaran",file7);
    formData.append("CWStatusPreliminary",file8);
    formData.append("BillOfQuantities",file9);
    formData.append("CWStatusWork",file10);
    formData.append("ApprovedPlan",file11);
    formData.append("CWStatusPostImages",file12);
    formData.append("MethodStatementFile",file13);
    formData.append("CWTCChecklist",file14);
    formData.append("Others",file15);
    formData.append("NCRForm",file16);
    formData.append("DesignConcept",file17);
    formData.append("CPCDocumnet",file18);
    formData.append("DetailedDesign",file19);
    formData.append("ShopDrawings",file20);
    formData.append("SchematicDiagram",file21);
    formData.append("SiteHandoverLetter",file22);



    const req = new HttpRequest('POST', `${this.serviceApiUrl}assetSecondary/addWithFiles`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
    // return this.http.post(this.serviceApiUrl+"assetSecondary/add",tassetObj);

  }
  public saveAssetSecondaryLE(tassetObj,file1:File,fileNamePlate:File,file3:File,file4:File,file5:File,file6:File,file7:File,file8:File,file9:File,file10:File,file11:File,file12:File
    ,file13:File,file14:File,file15:File,file16:File,file17:File,file18:File,file19:File,file20:File,file21:File,file22:File,file23:File){

    const formData: FormData = new FormData();
    formData.append("leDetails",JSON.stringify(tassetObj));
    // file2
    formData.append("FormA04",file23);
    formData.append("EquipmentPicture",file1);
    formData.append("NumberPlatePicture",fileNamePlate);
    formData.append("DeliveryOrder",file3);
    formData.append("BETCChecklist",file4);
    formData.append("TCCertificate",file5);
    formData.append("VarDocuments",file6);
    formData.append("SuratTawaran",file7);
    formData.append("CWStatusPreliminary",file8);
    formData.append("BillOfQuantities",file9);
    formData.append("CWStatusWork",file10);
    formData.append("ApprovedPlan",file11);
    formData.append("CWStatusPostImages",file12);
    formData.append("MethodStatementFile",file13);
    formData.append("CWTCChecklist",file14);
    formData.append("Others",file15);
    formData.append("NCRForm",file16);
    formData.append("DesignConcept",file17);
    formData.append("CPCDocumnet",file18);
    formData.append("DetailedDesign",file19);
    formData.append("ShopDrawings",file20);
    formData.append("SchematicDiagram",file21);
    formData.append("SiteHandoverLetter",file22);



    const req = new HttpRequest('POST', `${this.serviceApiUrl}/ledetails/addWithFiles`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
    // return this.http.post(this.serviceApiUrl+"assetSecondary/add",tassetObj);

  }

  // Asset modify{}
  public fetchAssetModify() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + 'asset_modify/all');
  }

  public saveAssetModify(data) {
    return this.http.post(this.serviceApiUrl + "asset_modify/add", data);
  }
  public saveAuthorization(data) {
    return this.http.post(this.serviceApiUrl + "TrackUpdateInspectedNotify/addTrackAndUpdate", data);
  }
  public fetchTrackUpdate() {
    // return this.http.get<Observable<any>>(this.serviceApiUrl + 'TrackUpdateInspectedNotify/allTrackAndUpdate');
    return this.http.get<Observable<any>>(this.serviceApiUrl + 'endOfWarrentyProcess/all');
  }
  public updateForApproveViewCompleted(data) {
    //
    console.log("service get;;;;;")
    return this.http.put(this.serviceApiUrl + 'TrackUpdateInspectedNotify/updateInspectedApprove', data);

  }
  public updateForModify(data) {
    //
    console.log("service get;;;;;")
    return this.http.put(this.serviceApiUrl + 'asset_modify/update', data);

  }

  public updateDetails(data) {
    //
    
    return this.http.post(this.serviceApiUrl + 'asset_modify/updateDetails', data);

  }

  updateModifyWithFile(data, file) {
    //
    const formData: FormData = new FormData();
    formData.append("assetModify", JSON.stringify(data));
    formData.append("File", file);
    console.log("service put;;;;;", data)
    // return this.http.put(this.serviceApiUrl + 'm_manufacturer/updateWithFile',data);
    const req = new HttpRequest('POST', `${this.serviceApiUrl}/asset_modify/addWithFile`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);

  }

  fetchTrackUpdateFilterDatas(stateId, districtId, circleId, clinicId) {
    let data = "";

    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicId != null && clinicId != "") {
      data += "clinicId=" + clinicId + "&"
    }

    console.log("datas passed", data)
    return this.http.get(this.serviceApiUrl + 'TrackUpdateInspectedNotify/allTrackAndUpdate?' + data);
  }
  fetchViewCompletedFilterDatas(stateId, districtId, circleId, clinicId) {
    let data = "";

    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicId != null && clinicId != "") {
      data += "clinicId=" + clinicId + "&"
    }

    console.log("datas passed", data)
    return this.http.get(this.serviceApiUrl + 'TrackUpdateInspectedNotify/allInspected?' + data);
  }
  fetchModifyFilterDatas(stateId, districtId, clinicId, ownershipId) {
    let data = "";

    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (clinicId != null && clinicId != "") {
      data += "clinicId=" + clinicId + "&"
    }
    if (ownershipId != null && ownershipId != "") {
      data += "ownershipId=" + ownershipId + "&"
    }

    console.log("datas passed", data)
    return this.http.get(this.serviceApiUrl + 'asset_modify/allDataWithFilterApply?' + data);
  }

  public fetchByBeNumber(beNumber) {

    // console.log("working fine",beNumber)
    return this.http.post(this.serviceApiUrl + "mAsset/fetchByBenumber", beNumber);

  }

  // public fetchGroupByWorkGroup(stateId ?: any,districtId ?: any,circleId ?: any,clinicCategoryId ?: any,ownershipId ?: any){

  //   return this.http.get(this.serviceApiUrl + "mAsset/groupByWorkGroup?stateId="+stateId+"?districtId="+districtId+"?circleId="+circleId+"?clinicCategoryId="+clinicCategoryId+"?ownershipId="+ownershipId);

  // }

  // Asset Report Detail ...

  public fetchGroupByWorkGroup() {
    return this.http.get(this.serviceApiUrl + "mAsset/groupByWorkGroup");
  }

  public fetchGroupByAssetCategory(workGroupId) {
    return this.http.get(this.serviceApiUrl + "mAsset/groupByAssetCategory?workGroupId=" + workGroupId);
  }

  public fetchGroupByBeNumber(workGroupId, assetCategoryId) {
    return this.http.get(this.serviceApiUrl + "mAsset/groupByBeNumber?workGroupId=" + workGroupId + "&assetCategoryId=" + assetCategoryId);
  }
  public fetchAuthorization() {

    return this.http.get<Observable<any>>(this.serviceApiUrl + 'endOfWarrentyProcess/all');

  }

  public fetchAuthorizationUpdate(date) {

    return this.http.put(this.serviceApiUrl + "mAsset/fetchByBenumber/Update", date);

  }
  public fetchAllTrackAdd(data) {

    return this.http.post(this.serviceApiUrl + "endOfWarrentyProcess/add", data);

  }
  public fetchAllTrackUpdate(data) {

    return this.http.put(this.serviceApiUrl + 'endOfWarrentyProcess/update', data);

  }
  public fetchAllTrack() {

    return this.http.get<Observable<any>>(this.serviceApiUrl + 'endOfWarrentyProcess/all');

  }
  public saveTrackUpdate(data) {
    return this.http.put(this.serviceApiUrl + "TrackUpdateInspectedNotify/updateTrackAndUpdate", data);
  }
  public fetchViewCompleted() {

    return this.http.get<Observable<any>>(this.serviceApiUrl + 'TrackUpdateInspectedNotify/allInspected');

  }
  public fetchAllStateReport() {

    return this.http.get<Observable<any>>(this.serviceApiUrl + 'assetReportNew/fetchGroupByState?year=2022');

  }
  public fetchAllDistrictReport(stateId, ownershipId, clinicCategoryId, workGroupId, year) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }

    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }

    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (workGroupId != null && workGroupId != "" && workGroupId != 0) {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (year != null && year != "") {
      data += "year=" + year + "&"
    }


    console.log("datas passed", data)
    return this.http.get(this.serviceApiUrl + 'assetReportNew/fetchGroupByDistrict?' + data);

    // return this.http.get<Observable<any>>(this.serviceApiUrl + 'assetReportNew/fetchGroupByDistrict?stateId=' +stateId );

  }
  public fetchAllClinicReport(stateId, districtId, ownershipId, clinicCategoryId, workGroupId, year) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }

    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }

    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (workGroupId != null && workGroupId != "" && workGroupId != 0) {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (year != null && year != "") {
      data += "year=" + year + "&"
    }


    console.log("datas passed", data)
    return this.http.get(this.serviceApiUrl + 'assetReportNew/fetchGroupByClinic?' + data);


    // return this.http.get<Observable<any>>(this.serviceApiUrl + 'assetReportNew/fetchGroupByClinic?stateId='+stateId+'&districtId='+districtId );

  }
  public fetchAllBENumber(stateId, districtId, clinicId, ownershipId, clinicCategoryId, workGroupId, year) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (clinicId != null && clinicId != "") {
      data += "clinicId=" + clinicId + "&"
    }

    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }

    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (workGroupId != null && workGroupId != "" && workGroupId != 0) {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (year != null && year != "") {
      data += "year=" + year + "&"
    }


    console.log("datas passed", data)
    return this.http.get(this.serviceApiUrl + 'assetReportNew/fetchGroupByBeNumber?' + data);


    // return this.http.get<Observable<any>>(this.serviceApiUrl + 'assetReportNew/fetchGroupByBeNumber?stateId='+stateId+'&districtId='+districtId+'&clinicId='+clinicId );

  }
  public fetchAllFilteredDatas(ownershipId, clinicCategoryId, workGroupId, year) {
    let data = ""

    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }

    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (workGroupId != null && workGroupId != "") {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (year != null && year != "") {
      data += "year=" + year + "&"
    }


    console.log("datas passed", data)
    return this.http.get(this.serviceApiUrl + 'assetReportNew/fetchGroupByState?' + data);
    // return this.http.get(this.serviceApiUrl + 'assetReportNew/fetchGroupByState?stateId=' )
  }

  addFileObjBeNumber(data) {
    console.log(data)
    const formData: FormData = new FormData();
    formData.append('beNumber', data.beNumber);
    formData.append('formA04', data.formA04);

    let obj = {};

    formData.forEach((value, key) => obj[key] = value);
    console.log("On service Data", obj);

    return this.http.post(this.serviceApiUrl + 'assetFileStorage/add', obj);
  }
  public fetchBENumberConditionalStatus(beNumber) {

    // console.log("working fine",beNumber)

    return this.http.post(this.serviceApiUrl + "conditionalStatus/fetchConditionalBeNumber", beNumber);

  }
  public fetchBENumberAccesories(beNumber) {

    // console.log("working fine",beNumber)

    return this.http.get(this.serviceApiUrl + "mAssetAccessories/findByBeNumber?beNumber=" + beNumber);

  }
  fetchAllAssetSecondarySubCategoryDatas(beNumber) {
    return this.http.get(this.serviceApiUrl + "assetSecondarySubCategory/fetchByBenumber?beNumber=" + beNumber)
  }
  fetchAllSubCategoryDatas(beNumber) {
    return this.http.get(this.serviceApiUrl + "assetSubCategory/fetchByBeNumber?beNumber=" + beNumber)
  }
  fetchByBeNumberFromStandardComponentsDatas(beNumber) {
    return this.http.get(this.serviceApiUrl + "assetStandardAccessories/findByBeNumber?beNumber=" + beNumber);

  }
  public fetchBENumberLocationChange(beNumber) {

    // console.log("working fine",beNumber)

    return this.http.post(this.serviceApiUrl + "locationChange/fetchLocationBeNumber", beNumber);

  }
  fetchBENumberLoanEqui(beCategoryId) {
    return this.http.get(this.serviceApiUrl + "loanEquipment/fetchByBeCategory?beCategoryId=" + beCategoryId);

  }
  fetchBENumberTestEqui(beCategoryId) {
    return this.http.get(this.serviceApiUrl + "testEquipment/fetchByBeCategory?beCategoryId=" + beCategoryId);

  }

  fetchAllLoanEquipmentShare() {
    return this.http.get<Observable<any>>(this.serviceApiUrl + "beCodeAndLeCode/all");
  }
  public fetchBENumberImage(assetCategoryId) {

    // console.log("working fine",beNumber)

    return this.http.get(this.serviceApiUrl + "assetCategoryImage/fetchEncodedImage?assetCategoryId=" + assetCategoryId, { responseType: "text" });

  }

  fetchByBeNumberInfoFile(beNumber) {
    return this.http.get(this.serviceApiUrl + "varV1S2/fetchByBenumber?beNumber=" + beNumber);


  }
  fetchByBeNumberInfoFiletwo(beNumber) {
    return this.http.get(this.serviceApiUrl + "varV1S1/fetchByBenumber?beNumber=" + beNumber);


  }
  fetchByInternalVs2File(beNumber) {
    return this.http.get(this.serviceApiUrl + "internalVarV1S2/fetchByBenumber?beNumber=" + beNumber);


  }
  fetchByInternalVs4File(beNumber) {
    return this.http.get(this.serviceApiUrl + "internalVarV1S4/fetchByBenumber?beNumber=" + beNumber);


  }


  public fetchAllLocationReport(
    stateId, districtId, circleId, clinicTypeId, workGroupId,
    beCategoryId, ownershipId, clinicCategoryId, warrantyStartDate, warrantyDateStartDateTo,
    warrantyEndDate, warrantyEndDateTo, installationDateFrom, installationDateTo, purchaseDateFrom, purchaseDateTo,clinicId) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicId != null && clinicId != "" && clinicId != undefined) {
      data += "clinicId=" + clinicId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (workGroupId != null && workGroupId != "" && workGroupId != 0) {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (beCategoryId != null && beCategoryId != "") {
      data += "beCategoryId=" + beCategoryId + "&"
    }
    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }

    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }

    if (warrantyStartDate != null && warrantyStartDate != "") {
      data += "warrantyStartDate=" + warrantyStartDate + "&"
    }
    if (warrantyDateStartDateTo != null && warrantyDateStartDateTo != "") {
      data += "warrantyDateStartDateTo=" + warrantyDateStartDateTo + "&"
    }
    if (warrantyEndDate != null && warrantyEndDate != "") {
      data += "warrantyEndDate=" + warrantyEndDate + "&"
    }
    if (warrantyEndDateTo != null && warrantyEndDateTo != "") {
      data += "warrantyEndDateTo=" + warrantyEndDateTo + "&"
    }
    if (installationDateFrom != null && installationDateFrom != "") {
      data += "installationDateFrom=" + installationDateFrom + "&"
    }
    if (installationDateTo != null && installationDateTo != "" && installationDateTo != 0) {
      data += "installationDateTo=" + installationDateTo + "&"
    }
    if (purchaseDateFrom != null && purchaseDateFrom != "") {
      data += "purchaseDateFrom=" + purchaseDateFrom + "&"
    }
    if (purchaseDateTo != null && purchaseDateTo != "" && purchaseDateTo != 0) {
      data += "purchaseDateTo=" + purchaseDateTo + "&"
    }

    console.log("datas passed", data)
    return this.http.get(this.serviceApiUrl + 'latestAsset/assetReportByFilter?' + data);


    // return this.http.get<Observable<any>>(this.serviceApiUrl + 'assetReportNew/fetchGroupByClinic?stateId='+stateId+'&districtId='+districtId );

  }
  fetchAllBeTypeCount(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    ageFrom, ageTo, ownershipId,) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (ageFrom != null && ageFrom != "") {
      data += "ageFrom=" + ageFrom + "&"
    }
    if (ageTo != null && ageTo != "") {
      data += "ageTo=" + ageTo + "&"
    }
    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/ageingReportCount?" + data);
  }
  fetchIndividualBETypeCount(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    ageFrom, ageTo, ownershipId) {
    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (ageFrom != null && ageFrom != "") {
      data += "ageFrom=" + ageFrom + "&"
    }
    if (ageTo != null && ageTo != "") {
      data += "ageTo=" + ageTo + "&"
    }
    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/ageingData?" + data);
  }
  fetchAllLocationSummaryReport(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    workGroupId, beCategoryId) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (workGroupId != null && workGroupId != "") {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (beCategoryId != null && beCategoryId != "") {
      data += "beCategoryId=" + beCategoryId + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/conditionalWiseCount?" + data);
  }
  fetchAllActiveSummaryReport(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    workGroupId, beCategoryId, ownershipId) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (workGroupId != null && workGroupId != "") {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (beCategoryId != null && beCategoryId != "") {
      data += "beCategoryId=" + beCategoryId + "&"
    }
    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/activeWiseData?" + data);
  }
  fetchAlldeActiveSummaryReport(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    workGroupId, beCategoryId, ownershipId) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (workGroupId != null && workGroupId != "") {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (beCategoryId != null && beCategoryId != "") {
      data += "beCategoryId=" + beCategoryId + "&"
    }
    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/deActiveWiseData?" + data);
  }
  fetchAllwithinWarrantySummaryReport(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    workGroupId, beCategoryId, ownershipId) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (workGroupId != null && workGroupId != "") {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (beCategoryId != null && beCategoryId != "") {
      data += "beCategoryId=" + beCategoryId + "&"
    }
    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/underWarrantyData?" + data);
  }
  fetchAlloutSideWarrantySummaryReport(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    workGroupId, beCategoryId, ownershipId) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (workGroupId != null && workGroupId != "") {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (beCategoryId != null && beCategoryId != "") {
      data += "beCategoryId=" + beCategoryId + "&"
    }
    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/beyondWarrantyData?" + data);
  }
  fetchAllLocationOpenWR(stateId, districtId, circleId, clinicCategoryId, clinicTypeId,
    workGroupId, beCategoryId, workOrderType) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (workGroupId != null && workGroupId != "") {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (beCategoryId != null && beCategoryId != "") {
      data += "beCategoryId=" + beCategoryId + "&"
    }
    if (workOrderType != null && workOrderType != "") {
      data += "workOrderType=" + workOrderType + "&"
    }
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/openWorkOrder?" + data);
  }
  fetchClinicNameWiseBreakDownCountCompleted(stateId,circleId,districtId){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiCompletedCount?stateId=" + stateId +"&circleId=" + circleId +"&districtId=" + districtId)}
    fetchClinicNameWiseBreakDownCountNotCompleted(stateId,circleId,districtId){
      return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiNotCompletedCount?stateId=" + stateId +"&circleId=" + circleId +"&districtId=" + districtId)}
      fetchClinicNameWiseBreakDownCountNotCompletedPPM(stateId,circleId,districtId){
        return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiNotCompletedCountPPm?stateId=" + stateId +"&circleId=" + circleId +"&districtId=" + districtId)}
    
  

    fetchClinicNameWiseBreakDownCountCompletedPPM(stateId,circleId,districtId){
      return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiCompletedCountPpm?stateId=" + stateId +"&circleId=" + circleId +"&districtId=" + districtId)} 
   fetchStateWiseBreakDownCount(){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/statewiseBreakdownCount")}

    fetchStateWiseBreakDownCountCompleted(stateId){
      return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiCompletedCount?stateId=" + stateId)}
      fetchStateWiseBreakDownCountCompletedPPM(stateId){
        return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiCompletedCountPpm?stateId=" + stateId)

      }
      fetchDistrictWiseBreakDownCountCompleted(stateId,circleId){
        return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiCompletedCount?stateId="+stateId+"&circleId="+circleId)}
        fetchDistrictWiseBreakDownCountCompletedPPM(stateId,circleId){
          return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiNotCompletedCountPPm?stateId="+stateId+"&circleId="+circleId)} 
          fetchStateWiseBreakDownCountNotCompletedtwoPPM(stateId,circleId){
            return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiNotCompletedCountPPm?stateId=" + stateId+"&circleId="+circleId)}
        fetchDistrictWiseBreakDownCountCompletedTwo(stateId,circleId,districtId){
          return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiCompletedCount?stateId="+stateId+"&circleId="+circleId+"&districtId=" + districtId)}
          fetchDistrictWiseBreakDownCountCompletedTwoPPM(stateId,circleId,districtId){
            return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiCompletedCountPpm?stateId="+stateId+"&circleId="+circleId+"&districtId=" + districtId)}
            fetchDistrictWiseBreakDownCountNotCompletedTwoPPM(stateId,circleId,districtId){
              return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiNotCompletedCountPPm?stateId="+stateId+"&circleId="+circleId+"&districtId=" + districtId)}
      fetchStateWiseBreakDownCountNotCompleted(stateId){
        return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiNotCompletedCount?stateId=" + stateId)}
        fetchStateWiseBreakDownCountNotCompletedPPM(stateId){
          return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiNotCompletedCountPPm?stateId=" + stateId)
        }
        fetchStateWiseBreakDownCountNotCompletedtwo(stateId,circleId){
          return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiNotCompletedCount?stateId=" + stateId+"&circleId="+circleId)}
          fetchdistrictWiseBreakDownCountNotCompletedtwo(stateId,circleId,districtId){
            return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/kpiNotCompletedCount?stateId=" + stateId+"&circleId="+circleId+"&districtId=" + districtId)}
  fetchCircleWiseBreakDownCount(stateId){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/circleWiseBreakdownCount?stateId=" + stateId)}
  fetchDistrictWiseBreakDownCount(stateId,circleId){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/districtWiseBreakdownCount?stateId=" + stateId +"&circleId=" + circleId)}
  fetchClinicWiseBreakDownCount(stateId,circleId,districtId){
   return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/clinicWiseBreakdownCount?stateId=" + stateId +"&circleId=" + circleId +"&districtId=" + districtId)}
   fetchStateWisePPMCount(){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/statewiseppmCount")}
  fetchCircleWisePPMCount(stateId){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/circleWisePPmCount?stateId=" + stateId)}
  fetchDistrictWisePPMCount(stateId,circleId){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/districtWisePpmCount?stateId=" + stateId +"&circleId=" + circleId)}
  fetchClinicWisePPMCount(stateId,circleId,districtId){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "latestAsset/clinicwiseppmCount?stateId=" + stateId +"&circleId=" + circleId +"&districtId=" + districtId)}
  fetchBENumberMaterialHistorydata(beNumber) {
    return this.http.get<Array<any>>(this.serviceApiUrl + 'sparesHistory/sparesMrData?beNumber=' + beNumber );}
  saveJkkpRequest(data) {
      return this.http.put<Observable<any>>(this.serviceApiUrl + "mAsset/updateStatutoryByBeNumber", data);
  }


  public fetchAllJkkpReport(
    stateId, districtId, circleId, clinicTypeId, workGroupId,
    beCategoryId, ownershipId, clinicCategoryId, warrantyStartDate, warrantyDateStartDateTo,
    warrantyEndDate, warrantyEndDateTo, installationDateFrom, installationDateTo, purchaseDateFrom, purchaseDateTo,clinicId) {

    let data = ""
    if (stateId != null && stateId != "") {
      data += "stateId=" + stateId + "&"
    }
    if (districtId != null && districtId != "") {
      data += "districtId=" + districtId + "&"
    }
    if (circleId != null && circleId != "") {
      data += "circleId=" + circleId + "&"
    }
    if (clinicId != null && clinicId != "" && clinicId != undefined) {
      data += "clinicId=" + clinicId + "&"
    }
    if (clinicTypeId != null && clinicTypeId != "") {
      data += "clinicTypeId=" + clinicTypeId + "&"
    }
    if (workGroupId != null && workGroupId != "" && workGroupId != 0) {
      data += "workGroupId=" + workGroupId + "&"
    }
    if (beCategoryId != null && beCategoryId != "") {
      data += "beCategoryId=" + beCategoryId + "&"
    }
    if (ownershipId != null && ownershipId != "" && ownershipId != 0) {
      data += "ownershipId=" + ownershipId + "&"
    }

    if (clinicCategoryId != null && clinicCategoryId != "" && clinicCategoryId != 0) {
      data += "clinicCategoryId=" + clinicCategoryId + "&"
    }

    if (warrantyStartDate != null && warrantyStartDate != "") {
      data += "warrantyStartDate=" + warrantyStartDate + "&"
    }
    if (warrantyDateStartDateTo != null && warrantyDateStartDateTo != "") {
      data += "warrantyDateStartDateTo=" + warrantyDateStartDateTo + "&"
    }
    if (warrantyEndDate != null && warrantyEndDate != "") {
      data += "warrantyEndDate=" + warrantyEndDate + "&"
    }
    if (warrantyEndDateTo != null && warrantyEndDateTo != "") {
      data += "warrantyEndDateTo=" + warrantyEndDateTo + "&"
    }
    if (installationDateFrom != null && installationDateFrom != "") {
      data += "installationDateFrom=" + installationDateFrom + "&"
    }
    if (installationDateTo != null && installationDateTo != "" && installationDateTo != 0) {
      data += "installationDateTo=" + installationDateTo + "&"
    }
    if (purchaseDateFrom != null && purchaseDateFrom != "") {
      data += "purchaseDateFrom=" + purchaseDateFrom + "&"
    }
    if (purchaseDateTo != null && purchaseDateTo != "" && purchaseDateTo != 0) {
      data += "purchaseDateTo=" + purchaseDateTo + "&"
    }

    console.log("datas passed", data)
    return this.http.get(this.serviceApiUrl + 'latestAsset/assetAndAccessoriesReportByFilter?' + data);


    // return this.http.get<Observable<any>>(this.serviceApiUrl + 'assetReportNew/fetchGroupByClinic?stateId='+stateId+'&districtId='+districtId );

  }
  downloadFileForConditionalChange(fileId,fileKey){
    return this.http.get(this.serviceApiUrl + "conditionalStatus/downloadBeHistoryFiles?fileId=" +fileId +"&fileKey=" +fileKey);
  }
}
